import EndScreen from './EndScreen';

export default EndScreen;


// WEBPACK FOOTER //
// /src/components/endScreen/index.js